import PropTypes from "prop-types"
import React from "react"

import VideoButton from "./VideoButton"
import Overlay from "./Overlay"
class TheaterVideo extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      form: "two-lines",
      position: "right",
      isOpen: false,
      isOpening: false,
      isClosing: false,
    }
    this.toggleTheater = this.toggleTheater.bind(this)
    this.escFunction = this.escFunction.bind(this)
  }
  componentDidMount() {
    var menu = document.getElementById("mainNav")
    var pause = document.getElementById("sizzlePause")
    this.menu = menu
    this.pauseButton = pause

    document.addEventListener("keydown", this.escFunction, false)
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false)
  }

  escFunction(event) {
    if (event.keyCode === 27 && this.state.isOpen) {
      this.toggleTheater()
    }
  }

  toggleTheater() {
    //todo

    if (this.state.isOpen) {
      if (this.pauseButton) {
        setTimeout(() => {
          this.pauseButton.style.display = "block"
        }, 450)
      }

      this.setState(
        prevState => ({
          ...prevState,
          isClosing: !prevState.isClosing,
          playing: false
        }),
        function() {
          setTimeout(() => {
            this.setState(prevState => ({
              ...prevState,
              isOpen: !prevState.isOpen,
              isClosing: !prevState.isClosing,
            }))
            this.menu.style.zIndex = "100"
          }, 450)
        }
      )
      // Make sure to sync this setTimeout time with the one in the .scss animation time
    } else if (!this.state.isOpen) {
      this.menu.style.zIndex = "0"
      if (this.pauseButton) {
        this.pauseButton.style.display = "none"
      }
      this.setState(prevState => ({
        ...prevState,
        isOpen: !prevState.isOpen,
        isOpening: !prevState.isOpening,
      }))
      setTimeout(() => {
        this.setState(prevState => ({
          ...prevState,
          isOpening: !prevState.isOpening,
          playing: true
        }))
      }, 450)
      // Make sure to sync this setTimeout time with the one in the .scss animation time
    }
  }

  render() {
    const childrenWithProps = React.Children.map(this.props.children, child =>
      React.cloneElement(child, { onClick: this.toggleTheater })
    )

    var hasWatchVideo = true
    var onlyButton = false
    var overVideo = false
    var controls = true
    var playing = true
    var sizzleButton = false

    if (this.props.hasWatchVideo === false) {
      hasWatchVideo = false
    }
    if (this.props.onlyButton === true) {
      onlyButton = true
    } else {
      if (this.props.overVideo === true) {
        overVideo = true
      }
    }
    if (this.props.controls === false) {
      controls = false
    }
    if (this.props.playing === false) {
      playing = false
    }
    if (this.props.sizzleButton === true) {
      sizzleButton = true
    }

    return (
      <>
        <Overlay
          toggleTheater={this.toggleTheater}
          isOpen={this.state.isOpen}
          isClosing={this.state.isClosing}
          isOpening={this.state.isOpening}
          videoUrl={this.props.videoUrl}
          controls={controls}
          playing={playing}
          compId={this.props.compId}

          //ext={this.extControl}
        />
        {hasWatchVideo && !onlyButton && (
          <div id={this.props.compId} className="image-button-wrapper">
            <VideoButton
              language={this.props.language}
              toggleTheater={this.toggleTheater}
              overVideo={overVideo}
            />
            {this.props.children}
          </div>
        )}
        {onlyButton && sizzleButton && (
          <div id={this.props.compId}>
            <VideoButton
              language={this.props.language}
              toggleTheater={this.toggleTheater}
              overVideo={overVideo}
              sizzleButton={sizzleButton}
            />
          </div>
        )}
        {onlyButton && !sizzleButton && this.props.slideButton && (
          <div className="slideVidButton">
            <VideoButton
              language={this.props.language}
              toggleTheater={this.toggleTheater}
              overVideo={overVideo}
            />
          </div>
        )}
        {onlyButton && !sizzleButton && !this.props.slideButton && (
          <VideoButton
            language={this.props.language}
            toggleTheater={this.toggleTheater}
            overVideo={overVideo}
          />
        )}
        {!hasWatchVideo && childrenWithProps}
      </>
    )
  }
}

TheaterVideo.propTypes = {
  children: PropTypes.element,
  videoUrl: PropTypes.string,
  controls: PropTypes.bool,
  playing: PropTypes.bool,
  overVideo: PropTypes.bool,
  hasWatchVideo: PropTypes.bool,
  onlyButton: PropTypes.bool,
}

export default TheaterVideo
